@if (publicFooterVm$ | async; as footerVm) {
<div id="footer" class="footer-wrapper" data-test="footer-section">
  <div class="footer-container">
    <div class="footer-menus-container">
      <div class="footer-badges-wrapper">
        <app-download-app-banner></app-download-app-banner>
      </div>

      <div class="footer-menus-section">
        <div class="footer-menu-container show-desktop">
          <div *ngFor="let menu of footerVm.footerMenus; trackBy: trackById" class="footer-menu-wrapper">
            <div class="menu">
              <div class="menu-label">
                <span class="menu-label-text">{{ menu.label }}</span>
              </div>
              <div class="menu-button-wrapper">
                <a
                  *ngFor="let button of menu.buttons; trackBy: trackById"
                  [href]="button.link"
                  target="_blank"
                  [attr.data-test]="getDataTestId(button.label)"
                  class="btn menu-button">
                  {{ button.label }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-menus show-non-desktop">
          <div *ngFor="let menu of footerVm.footerMenus; trackBy: trackById"
               class="accordion-wrapper"
               (keydown.enter)="toggleAccordion(menu.id)"
               tabindex="0">
            <div class="accordion-label" (click)="toggleAccordion(menu.id)">
              <h3>{{ menu.label }}</h3>
              @if (menu.buttons.length > 0) {
                <span class="chevron">
                  @if (footerVm.openAccordionId === menu.id) {
                    <iris-icon
                      name="expand_less"
                      [usage]="iconUsageTypes.STAND_ALONE"
                      [size]="iconSizes.MD"
                      colorToken="$color-neutral-white"
                    ></iris-icon>
                  } @else {
                    <iris-icon
                      name="expand_more"
                      [usage]="iconUsageTypes.STAND_ALONE"
                      [size]="iconSizes.MD"
                      colorToken="$color-neutral-white"
                    ></iris-icon>
                  }
                </span>
              }
            </div>
            <div
              class="accordion-items"
              [class.open]="footerVm.openAccordionId === menu.id"
            >
              <div *ngFor="let button of menu.buttons; trackBy: trackById">
                <a [href]="button.link" target="_blank" class="btn">
                  <h4>{{ button.label }}</h4>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-social-wrapper">
          <div id="social-navigation" class="social-navigation">
            <a
              *ngFor="let social of footerVm.socialButtons; trackBy: trackById"
              [href]="social.link"
              target="_blank"
              rel="noopener"
              class="btn social-btn"
            >
              <img
                [src]="'/assets/' + social.icon + '.svg'"
                [alt]="social.icon + ' logo'"
                class="social-icon"
              >
            </a>
          </div>
          <div class="newsletter-form">
            <!-- {TODO: YOR-1385 - Uncomment this when the form is ready} -->
            <!-- <signup-newsletter-form [isFooter]="true"></signup-newsletter-form> -->
          </div>
        </div>
      </div>
    </div>

    <div class="states-links-container">
      <div class="states-link-title">Find the right provider for you</div>
      <div class="states-links-tabs">
        <button
          class="states-tab"
          [class.active]="footerVm.activeTab === footerTabs.state"
          (click)="setActiveTab(footerTabs.state)">
          By State
        </button>
        <button
          class="states-tab"
          [class.active]="footerVm.activeTab === footerTabs.insurance"
          (click)="setActiveTab(footerTabs.insurance)">
          By Insurance
        </button>
        <button
          class="states-tab"
          [class.active]="footerVm.activeTab === footerTabs.specialty"
          (click)="setActiveTab(footerTabs.specialty)">
          By Specialty
        </button>
      </div>
      <div class="menu-button-wrapper multi-column">
        <ng-container [ngSwitch]="footerVm.activeTab">
          <ng-container *ngSwitchCase="footerTabs.state">
            <a *ngFor="let state of footerVm.states; trackBy: trackById"
               [href]="state.href"
               target="_blank"
               class="btn menu-button"
               [attr.data-test]="'states-links-link-' + state.name.toLowerCase()">
              {{ state.name }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="footerTabs.insurance">
            <a *ngFor="let insurance of footerVm.insurances; trackBy: trackBySlug"
               [href]="insurance.link"
               target="_blank"
               class="btn menu-button"
               [attr.data-test]="'insurance-link-' + insurance.slug">
              {{ insurance.title }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="footerTabs.specialty">
            <a *ngFor="let specialty of footerVm.specialties; trackBy: trackBySlug"
               [href]="specialty.link"
               target="_blank"
               class="btn menu-button"
               [attr.data-test]="'specialty-link-' + specialty.slug">
              {{ specialty.title }}
            </a>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="footer-bottom-container">
      <div class="logo">
        <a [href]="marketingBaseUrl" target="_blank">
          <img class="logo-img" src="/assets/sm-logos/logotype-white.svg" alt="SonderMind Logo" fetchpriority="low">
        </a>
      </div>
      <div class="footer-caption-container" data-test="footer-caption">
        @if (footerVm.globalText) {
          <div class="footer-caption" [innerHTML]="(footerVm.globalText.footerCaption ?? '') | unsafeHtml"></div>
        }
      </div>
    </div>
  </div>

  <div id="social-legal-navigation-wrapper" class="legal-section">
    <div id="legal-navigation" class="legal-navigation">
      <a
        *ngFor="let legal of footerVm.legalButtons; trackBy: trackById"
        [href]="legal.link"
        target="_blank"
        class="btn legal-link"
      >
        {{ legal.label }}
      </a>
    </div>
  </div>

  @if (footerVm.globalText) {
    <div class="copyright-section">
      <div class="copyright-content">
        <span class="small">{{ footerVm.globalText.copyright }}</span>
      </div>
    </div>
  }
</div>
}
